import { StyledCardWrapper } from 'modules/ai/nba/components/card/Card.styles';

interface CardProps {
  children: React.ReactNode;
  testId?: string;
}

export const Card = ({ children, testId }: CardProps) => {
  return <StyledCardWrapper data-test={testId}>{children}</StyledCardWrapper>;
};
